'use client';

import useSWR from 'swr';
import { useContext } from 'react';
import { profilesQuery } from './profilesQuery';
import UIProfileListingSection from './ProfileListingSection.client';
import { SanityDraftClientContext } from '@/components/context';

export default async function DraftModeProfileListingSection() {
  const { client } = useContext(SanityDraftClientContext);
  const { data } = useSWR('profiles', () =>
    client?.fetch<(typeof profilesQuery)[1]>(profilesQuery[0])
  );
  const filtered = data?.filter((profile) => !profile.hideFromListing);

  return <UIProfileListingSection profiles={filtered ?? []} />;
}
